import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED } from '../../../../share/util/api/polling';
import { CHECK_ROUTINE_RESULT_TYPE } from './constants';
import { stop } from './stop';
import { stopSessionTransition } from './stop_session_transition';

/** 実行処理
 * @param {instance} self 呼び出し元インスタンス
 */
export async function executeCheck(self) {
  try {
    self.isLoading = true;

    // バックエンドAPI POST,GET
    const token = session.getToken();
    const executeCheckResponse = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'execute_check'
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    // GPF再生中止確認表示が表示中の場合は、その後の処理を実施しない（同画面キャンセル押下時に改めて実行される）
    if (!executeCheckResponse || self.isCancelled) return;

    if (executeCheckResponse.data.status === REQUEST_STATUS_COMPLETED) {
      const checkRoutineData = executeCheckResponse.data.user_data.result;
      // 正常終了
      switch (checkRoutineData) {
        // セッション遷移無のルーチン停止
        case CHECK_ROUTINE_RESULT_TYPE.STOP:
        case CHECK_ROUTINE_RESULT_TYPE.OTHER:
          await stop(self, checkRoutineData);
          return;
        // セッション遷移有のルーチン停止
        case CHECK_ROUTINE_RESULT_TYPE.COOLING1:
        case CHECK_ROUTINE_RESULT_TYPE.COOLING2:
        case CHECK_ROUTINE_RESULT_TYPE.COOLING3:
          await stopSessionTransition(self, checkRoutineData);
          return;
        default:
          break;
      }
    } else {
      //異常終了
      await stop(self, CHECK_ROUTINE_RESULT_TYPE.OTHER);
      return;
    }

  } finally {
    // GPF再生中止確認表示が表示中の場合は、スピナー消去しない（_leaveCbエラー回避のため）
    if (!self.isCancelled) self.isLoading = false;
  }
}
